// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#pixel-audience-page .pixel-audience-column-form > div > .box-container {\n  box-shadow: none;\n}\n", "",{"version":3,"sources":["webpack://./src/css/pages/PixelAudience.styl"],"names":[],"mappings":"AACE;EACE,gBAAW;AAAf","sourcesContent":["#pixel-audience-page\n  .pixel-audience-column-form > div > .box-container\n    box-shadow none\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
